module.exports = __webpack_public_path__ + "static/fishbowl-thumbnail-84e4a343bf7c03a10f89c98339e2531a.png";